var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.625,
    cy: 12.5,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 0.5C5.99597 0.5 0.625 5.87097 0.625 12.5C0.625 19.129 5.99597 24.5 12.625 24.5C19.254 24.5 24.625 19.129 24.625 12.5C24.625 5.87097 19.254 0.5 12.625 0.5ZM18.5089 15.65C18.7363 15.8774 18.7363 16.2452 18.5089 16.4726L16.5927 18.3839C16.3653 18.6113 15.9976 18.6113 15.7702 18.3839L12.625 15.2097L9.475 18.3839C9.24758 18.6113 8.87984 18.6113 8.65242 18.3839L6.74113 16.4677C6.51371 16.2403 6.51371 15.8726 6.74113 15.6452L9.91532 12.5L6.74113 9.35C6.51371 9.12258 6.51371 8.75484 6.74113 8.52742L8.65726 6.61129C8.88468 6.38387 9.25242 6.38387 9.47984 6.61129L12.625 9.79032L15.775 6.61613C16.0024 6.38871 16.3702 6.38871 16.5976 6.61613L18.5137 8.53226C18.7411 8.75968 18.7411 9.12742 18.5137 9.35484L15.3347 12.5L18.5089 15.65Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e087cc72a368b49985ee020a603e834f.svg";
export { ForwardRef as ReactComponent };